import Model, { belongsTo, attr, hasMany } from '@ember-data/model'
import { Type } from '@warp-drive/core-types/symbols'
import type School from 'district-ui-client/models/school'
import type Teacher from 'district-ui-client/models/teacher'
import type Student from 'district-ui-client/models/student'
import type { SubscriptionType } from 'district-ui-client/domain/subscription-type'
import type BooleanTransform from 'district-ui-client/transforms/boolean'
import type StringTransform from 'district-ui-client/transforms/string'

export default class SchoolClass extends Model {
  @attr<StringTransform>('string') declare subscriptionType: SubscriptionType

  @attr<StringTransform>('string') declare name: string

  @attr<BooleanTransform>('boolean') declare mathseedsPrimeAccess: boolean

  @attr<BooleanTransform>('boolean') declare playroomAccess: boolean

  @attr<BooleanTransform>('boolean') declare gamesAccess: boolean

  @attr<BooleanTransform>('boolean') declare backgroundMusicDisabled: boolean

  @belongsTo<School>('school', { async: false, inverse: 'schoolClasses' }) declare school?: School

  @hasMany<Teacher>('teacher', { async: false, inverse: 'schoolClasses' }) declare teachers?: Teacher[]

  @hasMany<Student>('student', { async: false, inverse: 'schoolClasses' }) declare students?: Student[]

  get studentIds() {
    // @ts-expect-error - something wrong with relationship reference types
    return this.hasMany<Student, 'students'>('students').ids()
  }

  get studentCount() {
    return this.studentIds.length
  }

  [Type] = 'school-class' as const
}
